import { useTranslation } from "react-i18next";
import {Dialog} from '@base-ui/react/dialog';
import styles from "./YuJaDialog.module.css";
import {Separator} from "@base-ui/react/separator";
import YuJaButton from "./YuJaButton";
import {Button} from "@base-ui/react/button";
import {useEffect} from "react";


export default function YuJaDialog({
                                       popupRef,
                                       open,
                                       setOpen,
                                       title,
                                       closeText,
                                       leftButtonText,
                                       onLeft,
                                       submitText,
                                       onSubmit,
                                       onValidate,
                                       clearForm,
                                       isSubmitBtnDisabled=false,
                                       deleteText,
                                       onDelete,
                                       onClose,
                                       hasCloseIcon = true,
                                       centerAligned=true,
                                       fitContent = false,
                                       style={},
                                       children
                                   }) {
    const { t } = useTranslation();


    useEffect(() => {
        if (!open && !!clearForm) {
            clearForm();
        }
    }, [open]);



    const close = () => {
        if (!!onClose) {
            onClose();
        } else {
            setOpen(false);
        }
    }


    return (
        <Dialog.Root
            open={open}
            onOpenChange={(open) => {
                if (!open) {
                    close();
                }
            }}
        >
            <Dialog.Portal>
                <Dialog.Backdrop className={styles.Backdrop}/>
                <Dialog.Viewport className={styles.Viewport} style={{justifyContent: centerAligned ? "center" : "start"}}>
                    <Dialog.Popup
                        ref={popupRef}
                        className={fitContent ? `${styles.Popup} ${styles.PopupFitContent}` : styles.Popup}
                        style={{...style}}
                    >
                        <Dialog.Title className={styles.Title}>
                            {title}
                            {hasCloseIcon &&
                                <Button
                                    className={styles.CloseIconBtn}
                                    aria-label={t("accessibility.closeDialog")}
                                    onClick={() => close()}
                                >
                                    <CloseIcon/>
                                </Button>
                            }
                        </Dialog.Title>
                        <Separator orientation={"horizontal"} className={styles.Separator}/>
                        <div className={styles.Body}>
                            {children}
                        </div>
                        {(!!submitText || !!closeText) &&
                            <div className={styles.Actions}>
                                {!!closeText &&
                                    <YuJaButton
                                        size={"small"}
                                        type={"secondary"}
                                        onClick={() => close()}
                                    >
                                        {closeText}
                                    </YuJaButton>
                                }
                                {!!leftButtonText &&
                                    <YuJaButton
                                        size={"small"}
                                        onClick={async () => {
                                            if (!!onLeft) {
                                               await onLeft();
                                            }
                                            setOpen(false);
                                        }}
                                    >{submitText}</YuJaButton>
                                }

                                {!!submitText &&
                                    <YuJaButton
                                        size={"small"}
                                        disabled={isSubmitBtnDisabled}
                                        onClick={async () => {
                                            if (!!onValidate ) {
                                                let res = await onValidate();
                                                if (!res) {
                                                    return;
                                                }
                                            }


                                            if (!!onSubmit) {
                                               await onSubmit();
                                            }
                                            setOpen(false);
                                        }}
                                    >{submitText}</YuJaButton>
                                }

                                {!!deleteText &&
                                    <YuJaButton
                                        size={"small"}
                                        type={"delete"}
                                        onClick={async () => {
                                            if (!!onDelete) {
                                                await onDelete();
                                            }
                                            setOpen(false);
                                        }}
                                    >{deleteText}</YuJaButton>
                                }
                            </div>
                        }

                    </Dialog.Popup>
                </Dialog.Viewport >
            </Dialog.Portal>
        </Dialog.Root>
    );
}


function CloseIcon(props) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.75 5.25L5.25 18.75" stroke="#6B6B6B" strokeWidth="1.5" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path d="M18.75 18.75L5.25 5.25" stroke="#6B6B6B" strokeWidth="1.5" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>

    );
}

